import React from "react";
import AppBar from "components/layout/appBar";
import { Layout as RaLayout, LayoutProps } from "react-admin";
import { ProfileProvider } from "reactAdmin/resource/user/profileEdit";
import { Menu } from "components/layout/menu";

const Layout = (props: LayoutProps) => (
    <ProfileProvider>
        <RaLayout {...props} appBar={AppBar} menu={Menu} />
    </ProfileProvider>
);

export default Layout;